module.exports = __webpack_public_path__ + "img/Figa_reglog.9b91914d.png";